import { useUserStore } from '@/stores/system'
import type { RouteRecordRaw } from 'vue-router'
import { aliases } from '../aliases'

const lostPassword: RouteRecordRaw = {
	component: () => import('components/modules/Login/Password/Lost.vue'),
	name: 'lostPassword',
	path: 'password/lost',
	meta: {
		title: 'Passwort vergessen',
		icon: 'fal fa-lock',
	},
}
const resetPassword: RouteRecordRaw = {
	component: () => import('components/modules/Login/Password/Reset.vue'),
	meta: {
		title: 'Passwort zurücksetzen',
		icon: 'fal fa-unlock',
	},
	name: 'resetPassword',
	alias: aliases.password_set,
	path: '/password/reset/:token',
	props: true,
}

const defaultView: RouteRecordRaw = {
	name: 'login',
	path: '',
	component: () => import('components/modules/Login/Form.vue'),
}

const login: RouteRecordRaw = {
	beforeEnter: () => {
		const { isLoggedIn } = useUserStore()
		if (isLoggedIn) {
			return { name: 'dashboard' }
		} else {
			return true
		}
	},
	children: [defaultView, lostPassword, resetPassword],
	component: () => import('components/modules/Login/Login.vue'),
	meta: {
		requiresAuth: true,
	},
	path: '/',
}

export { login, lostPassword, resetPassword }
